import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { ChatInterface } from './components/ChatInterface';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { initializeOpenAI } from './services/openai';
import GPTStoreShoppingIndex from './pages/gptstore';
import { ResearchPage } from './pages/ResearchPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { FAQPage } from './pages/FAQPage';
import { MostPopularPage } from './pages/MostPopularPage';
import { ProductivityToolsPage } from './pages/ProductivityToolsPage';
import { ShoppingToolsPage } from './pages/ShoppingToolsPage';
import { BlogArticlePage } from './pages/BlogArticlePage';
import { ComparisonArticlePage } from './pages/ComparisonArticlePage';
import { ResearchGuideArticlePage } from './pages/ResearchGuideArticlePage';
import { initializeGA, trackPageView } from './services/analytics';
// Analytics tracker component
const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    // Track page view on location change
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
};
export function App() {
  const [conversations, setConversations] = useState([{
    id: 1,
    title: 'Shopping for a new laptop',
    active: true,
    messages: [{
      id: 1,
      type: 'assistant',
      content: "Welcome to Talking Catalogs! I'm your interactive catalog assistant. How can I help you today?"
    }]
  }]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [apiKeySet, setApiKeySet] = useState(false);
  // Initialize Google Analytics
  useEffect(() => {
    initializeGA();
  }, []);
  // Extract recommended products from the conversation
  const extractRecommendedProducts = messages => {
    const products = [];
    const urlRegex = /\[(.*?)\]\((https?:\/\/[^\s)]+)\)(?:.*?)\$(\d+(?:\.\d+)?)/g;
    const messagesToCheck = messages.slice(-10);
    messagesToCheck.forEach(message => {
      if (message.type === 'assistant') {
        let match;
        while ((match = urlRegex.exec(message.content)) !== null) {
          products.push({
            id: `${products.length + 1}`,
            title: match[1],
            image: getProductImage(match[1].toLowerCase()),
            url: match[2],
            price: `$${match[3]}`
          });
        }
      }
    });
    return products.length > 0 ? products : defaultRecommendedProducts;
  };
  const getProductImage = productName => {
    if (productName.includes('laptop') || productName.includes('ultrabook') || productName.includes('powerbook')) {
      return 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80';
    } else if (productName.includes('headphone') || productName.includes('airpods') || productName.includes('soundmaster')) {
      return 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80';
    } else if (productName.includes('phone') || productName.includes('galaxy') || productName.includes('iphone')) {
      return 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80';
    } else if (productName.includes('nintendo') || productName.includes('switch') || productName.includes('console')) {
      return 'https://images.unsplash.com/photo-1578303512597-81e6cc155b3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80';
    }
    return 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80';
  };
  const defaultRecommendedProducts = [{
    id: '1',
    title: 'Apple AirPods Pro (2nd Generation)',
    image: 'https://images.unsplash.com/photo-1600294037681-c80b4cb5b434?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80',
    price: '$249.99',
    url: 'https://chatgpt.com/g/g-68986d8f22748191b0f4b8839c3e1cfa-shopping-expert'
  }, {
    id: '2',
    title: 'Samsung Galaxy S23 Ultra 256GB',
    image: 'https://images.unsplash.com/photo-1678911820864-e5f41b4c19ca?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80',
    price: '$1,199.99',
    url: 'https://chatgpt.com/g/g-68986d8f22748191b0f4b8839c3e1cfa-shopping-expert'
  }, {
    id: '3',
    title: 'Sony WH-1000XM5 Wireless Noise Canceling Headphones',
    image: 'https://images.unsplash.com/photo-1546435770-a3e426bf472b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80',
    price: '$399.99',
    url: 'https://chatgpt.com/g/g-68986d8f22748191b0f4b8839c3e1cfa-shopping-expert'
  }, {
    id: '4',
    title: 'Nintendo Switch OLED Model with White Joy-Con',
    image: 'https://images.unsplash.com/photo-1578303512597-81e6cc155b3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80',
    price: '$349.99',
    url: 'https://chatgpt.com/g/g-68986d8f22748191b0f4b8839c3e1cfa-shopping-expert'
  }];
  const getRecommendedProducts = () => {
    const activeConversation = conversations.find(c => c.active) || conversations[0];
    return extractRecommendedProducts(activeConversation.messages);
  };
  const ChatUI = () => <div className="flex flex-col h-screen bg-gray-50" data-id="element-0">
      <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} user={user} apiKeySet={apiKeySet} data-id="element-1" />
      <div className="flex flex-1 overflow-hidden relative" data-id="element-2">
        <Sidebar conversations={conversations} setActiveConversation={setActiveConversation} addNewConversation={addNewConversation} isOpen={sidebarOpen} data-id="element-3" />
        <ChatInterface conversation={activeConversation} addMessage={addMessageToActiveConversation} recommendedProducts={getRecommendedProducts()} data-id="element-4" />
      </div>
    </div>;
  return <Router data-id="element-5">
      <AnalyticsTracker data-id="element-6" />
      <Routes data-id="element-7">
        {/* Main pages */}
        <Route path="/" element={<GPTStoreShoppingIndex data-id="element-9" />} data-id="element-8" />
        <Route path="/gptstore" element={<GPTStoreShoppingIndex data-id="element-11" />} data-id="element-10" />
        <Route path="/most-popular-ai-shopping-assistants" element={<MostPopularPage data-id="element-13" />} data-id="element-12" />
        <Route path="/productivity-tools" element={<ProductivityToolsPage data-id="element-15" />} data-id="element-14" />
        <Route path="/shopping-tools" element={<ShoppingToolsPage data-id="element-17" />} data-id="element-16" />
        <Route path="/research" element={<ResearchPage data-id="element-19" />} data-id="element-18" />
        <Route path="/about" element={<AboutPage data-id="element-21" />} data-id="element-20" />
        <Route path="/contact" element={<ContactPage data-id="element-23" />} data-id="element-22" />
        <Route path="/faq" element={<FAQPage data-id="element-25" />} data-id="element-24" />

        {/* Blog */}
        <Route path="/what-is-ai-shopping-assistant" element={<BlogArticlePage data-id="element-27" />} data-id="element-26" />
        <Route path="/shoppingexpert-vs-chatgpt" element={<ComparisonArticlePage data-id="element-29" />} data-id="element-28" />
        <Route path="/how-to-research-any-product" element={<ResearchGuideArticlePage data-id="element-31" />} data-id="element-30" />
        <Route path="/blog" element={<BlogArticlePage data-id="element-33" />} data-id="element-32" />

        {/* Demo */}
        <Route path="/conversational_commerce_demo" element={<ChatUI data-id="element-35" />} data-id="element-34" />

        {/* Redirect any other paths to home */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-37" />} data-id="element-36" />
      </Routes>
    </Router>;
}